export const PlatformFlow = Object.freeze({
  PatientExperience: "1",
  StaffExperience: "2",
});

export const AppPlatform = Object.freeze({
  Mobile: "mobile",
  Web: "web",
});
